import { collectApiErrorCodes } from '@/lib/chatReplyError';

const SURVEY_ALREADY_SUBMITTED = 'HTTP.ERROR.409.SURVEY.SUBMISSION.ALREADY_EXISTS';

/**
 * welya-api refuse un second POST de sondage en 400 de validation, avec ce code dans `details` :
 * la réponse existe déjà et se remplace par un PUT.
 */
export function isSurveyAlreadySubmittedError(error: unknown): boolean {
  if ((error as { code?: unknown } | null)?.code === 'CONFLICT') return true;
  return collectApiErrorCodes(error).includes(SURVEY_ALREADY_SUBMITTED);
}
